<template>
  <div class="page-details texture-bg-css">
    <div class="w">
      <div class="page-header"><Breadcrumb /></div>
      <div v-if="details" class="page-contents">
        <div class="page-content opening-hour-page" id="opening-hour">
          <div class="text-center content-title">
            <span class="inline-block line-css"></span>
            <span class="font-css"> <span>开放时间</span> OPENING HOURS </span>
            <span class="inline-block line-css"></span>
          </div>
          <div class="bgc-blue text-center clearfix cursor-default">
            <div
              class="opening-hour cx w-1/2 float-left"
              v-for="(val, key) in openingHour"
              :key="`key_${key}`"
            >
              <div class="opening-hour-content w-full relative color-yellow">
                <div class="minor-title opening-hour-content-title">
                  {{ key }}
                </div>
                <div class="minor-content">
                  <span class="w-1/2 inline-block">开放时间</span>
                  <span class="w-1/2 inline-block">{{ val.open }}</span>
                </div>
                <div class="minor-content">
                  <span class="w-1/2 inline-block">售票时间</span>
                  <span class="w-1/2 inline-block">{{ val.ticket }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-content ticket-page" id="ticket">
          <div class="text-center content-title">
            <span class="inline-block line-css"></span>
            <span class="font-css"> <span>购票指南</span> TICKETING GUIDE</span>
            <span class="inline-block line-css"></span>
          </div>
          <div class="text-left bgc-yellow clearfix ticket-bg-flower">
            <ul class="inline-block ticket-left cursor-default">
              <li
                class="tl-li relative"
                v-for="item in ticket"
                :key="item.name"
              >
                <img
                  class="tl-number absolute"
                  src="../../../static/images/public/up-light.png"
                  alt="1"
                />
                <div class="minor-title">
                  {{ item.name }} <span class="ml-15px">{{ item.enName }}</span>
                </div>
                <div
                  class="minor-content text-justify"
                  v-html="item.content"
                ></div>
              </li>
            </ul>
            <div class="inline-block ticket-right relative clearfix">
              <div class="tl-li relative cursor-default">
                <img
                  class="tl-number absolute"
                  src="../../../static/images/public/up-light.png"
                  alt="1"
                />
                <div class="minor-title">
                  {{ onlineTicket.name }}
                  <span class="ml-15px">{{ onlineTicket.enName }}</span>
                </div>
                <div class="minor-content">{{ onlineTicket.content }}</div>
              </div>
              <BookingOffice></BookingOffice>
            </div>
          </div>
        </div>
        <div class="page-content transportation-page" id="transportation">
          <div class="text-center content-title">
            <span class="inline-block line-css"></span>
            <span class="font-css">
              <span>交通信息</span> TRAFFIC INFORMATION</span
            >
            <span class="inline-block line-css"></span>
          </div>
          <div class="text-left bgc-blue">
            <div class="transportation clearfix">
              <div class="transportation-left w-2/5 h-full float-left">
                <MapBar></MapBar>
              </div>
              <div class="transportation-right w-3/5 h-full float-left">
                <div class="transportation-tab">
                  <ul
                    class="text-center clearfix w-full px-16 transportation-tab-title"
                  >
                    <li
                      v-for="item in tabList"
                      :key="item"
                      :class="
                        tab === item
                          ? 'transportation-tab-option active w-1/2 cursor-pointer float-left text-center'
                          : 'transportation-tab-option w-1/2 cursor-pointer float-left text-center'
                      "
                      @click="tabFn(item)"
                    >
                      {{ item }} <span class="line-vertical"></span>
                    </li>
                  </ul>
                  <ul
                    v-if="tab === '公共交通'"
                    class="w-full transportation-li minor-content cursor-default"
                  >
                    <li
                      v-for="item in publicTransportation"
                      :key="`public_${item.name}`"
                      class="relative mb-5"
                    >
                      <i class="point absolute"></i>
                      <div class="minor-title">{{ item.name }}</div>
                      <div class="text-sm text-justify">{{ item.content }}</div>
                    </li>
                  </ul>
                  <ul v-else class="w-full">
                    <li class="transportation-li self-driving">
                      <div class="minor-title relative">
                        <img
                          class="tl-number absolute"
                          src="../../../static/images/public/up-light.png"
                          alt="1"
                        />自驾 SELF-DRIVING
                      </div>
                      <ul class="minor-content">
                        <li class="relative">
                          <i class="point absolute"></i>
                          高速路口景德镇西－迎宾大道－昌江大道－中华北路－珠山中路187号
                        </li>
                        <li class="relative">
                          <i class="point absolute"></i>
                          景德镇东－308省道－高岭大道－景东大道－陶阳北路－朝阳路－珠山中路187号
                        </li>
                        <li class="relative">
                          <i class="point absolute"></i>
                          景德镇南－济广高速出口－生态路－206国道－昌南大道－珠山中路187号
                        </li>
                        <li class="relative">
                          <i class="point absolute"></i>
                          景德镇北－杭瑞高速－济广高速－生态路－昌南大道－珠山中路187号
                        </li>
                        <!-- <li class="relative">
                          <i class="point absolute"></i>
                          景德镇北出口－金岭大道－迎宾大道－瓷都大道－珠山中路187号
                        </li> -->
                      </ul>
                    </li>
                    <li class="transportation-li parking">
                      <div class="transportation-li-content">
                        <div class="minor-title relative">
                          <img
                            class="tl-number absolute"
                            src="../../../static/images/public/up-light.png"
                            alt="1"
                          />停车 PARKING
                        </div>
                        <ul class="minor-content">
                          <li class="relative">
                            <i class="point absolute"></i
                            >景德镇御窑厂国家考古遗址公园停车场
                          </li>
                          <li class="relative">
                            <i class="point absolute"></i>参考价：免费
                          </li>
                          <li class="relative">
                            <i class="point absolute"></i>库位：60
                          </li>
                          <li class="relative">
                            <i class="point absolute"></i
                            >地址：景德镇市珠山区珠山中路187号景区门口
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-content instructions-page cursor-default"
          id="instructions"
        >
          <div class="text-center content-title">
            <span class="inline-block line-css"></span>
            <span class="font-css"> <span>游览须知</span> TOUR GUIDE </span>
            <span class="inline-block line-css"></span>
          </div>
          <div class="text-left bgc-yellow">
            <ul class="instructions">
              <li class="instructions-li public-instructions clearfix">
                <div class="instructions-li-content">
                  <ul class="minor-content relative">
                    <div class="absolute instructions-icon"></div>
                    <li>
                      酗酒者、衣冠不整，无行为能力或限制行为能力者在无监护人陪伴情况下，谢绝入园。
                    </li>
                    <li>
                      景区内严禁吸烟、燃放烟花和携带易燃易爆物、管制械具，请自觉接受安保检查，景区内不得带宠物进园。
                    </li>
                  </ul>
                </div>
              </li>
              <li class="instructions-li public-instructions clearfix">
                <div class="instructions-li-content">
                  <ul class="minor-content relative">
                    <div class="absolute instructions-icon"></div>
                    <li>
                      游客须文明参观，保护文物公物，爱护花草树木，维护环境卫生，遵守公共秩序。
                    </li>
                    <li>
                      高龄老年人、残疾人士、未成年人需在监护人的看护下参观。
                    </li>
                    <li>
                      本园区为爱国主义教育基地，寒暑假针对青少玍开展御窑史话等文教活动。
                    </li>
                  </ul>
                </div>
              </li>
              <li class="instructions-li obey">
                <div class="instructions-li-content">
                  <ul class="minor-content relative">
                    <div class="absolute instructions-icon"></div>
                    <li class="lh-2">
                      如遇各类突发事件，请服从景区工作人员指挥。如景区有重大或临时性活动，请遵从景区安排，本须知解释权归景德镇市文博旅游发展有限公司。
                    </li>
                    <li>详情垂询：0798—8201378</li>
                    <li>投诉电话：13407987300/12315</li>
                    <li>急救电话：120</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="text-center no-data page-contents">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import link from '@/core/mixins/link'
import MapBar from '@/components/home/Map'
import BookingOffice from '@/components/home/BookingOffice'

export default {
  name: 'page-details',
  components: {
    Breadcrumb,
    MapBar,
    BookingOffice
  },
  mixins: [link],
  watch: {
    '$route.fullPath'() {
      this.initPageData()
    }
  },
  mounted: function() {
    this.initPageData()
  },
  data() {
    return {
      tab: '公共交通', // 一进页面显示第一个'历史概况'
      tabList: ['公共交通', '自驾 / 停车'],
      publicTransportation: [
        {
          name: '景德镇火车站',
          content: '乘 1路/25路/66路/33路/28路 到医药公司下西走150米即到。'
        },
        {
          name: '景德镇北站(高铁站)',
          content: '乘901路，到医药公司下西走150米即到。'
        },
        {
          name: '景德镇汽车西客站',
          content: '乘35路，华达百货下西走100米即到。'
        },
        {
          name: '飞机场',
          content:
            '景德镇机场位于市区西北面的浮梁县洪源镇罗家村，也叫景德镇罗家机场，距景德镇市中心的休闲广场约7公里。目前有直飞上海、深圳、北京、广州、赣州、安庆6条航线，并有经深圳飞成都、昆明、西安、海口、三亚、南宁、北海、湛江等城市的无缝转机航班。打车的话20分钟左右的车程，25元左右，景德镇市区内没有发往飞机场的公交车。'
        }
      ],
      openingHour: {
        春夏季: {
          open: '8:00-18:00',
          ticket: '8:00-17:00'
        },
        秋冬季: {
          open: '8:30-17:30',
          ticket: '8:30-16:00'
        }
      },
      ticket: [
        {
          name: '票价说明',
          enName: 'FARE DESCRIPTION',
          content:
            '参观门票每人60元／次（ 未成年人可享受免票 ）<br/>讲解：每名讲解服务费80元。'
        },
        {
          name: '优惠政策',
          enName: 'PREFERENTIAL POLICY',
          content:
            '记者凭本人记者证、60岁—65岁（不含65岁）人员凭本人身份证、24周岁以下学生凭本人《学生证》，可享受半价票优惠。本市市民凭身份证享受优惠。'
        },
        {
          name: '免票政策',
          enName: 'FREE TICKET POLICY',
          content:
            '18周岁以下免票。65岁以上（含65岁）人员凭本人身份证或《老年人优待证》、现役军人、伤残退役军人、部队离退休干部凭有效证件、残疾人凭本人残疾人证（三、四级）登记后可享受免票，下肢残疾人和其他重度残疾人的一名陪护人员与残疾人享有同等待遇。'
        }
        // {
        //   name: '购票须知',
        //   enName: 'TICKETING INSTRUCTIONS',
        //   content: '身高1.2米（含）以下儿童，须有家长陪同。'
        // }
      ],
      onlineTicket: {
        name: '网上购票',
        enName: 'ONLINE TICKET PURCHASE',
        content: '您可以通过下方渠道进行网络购票。'
      },
      id: null,
      category: null,
      details: []
    }
  },
  methods: {
    // tab栏切换
    tabFn(value) {
      this.tab = value
    },
    initPageData() {
      this.category = this.$route.params.category // this.$route.query.category // 从地址栏拿栏目的ID
      if (!this.category || this.category === '') {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.category === 'opening-hour'
      } else {
        document.getElementById(this.category).scrollIntoView()
      }
    },
    newPageJump(item) {
      window.open(item.link, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.page-details {
  min-height: 80vh;
  .page-contents {
    padding: 0 0 88px 0;
  }
  // 公用
  .minor-title {
    font-size: 18px;
    color: $c-white;
    line-height: 50px;
  }
  .minor-content {
    font-size: 14px;
    line-height: 30px;
    color: $c-white;
    .minor-content-point {
      display: inline-block;
      width: 2px;
      height: 2px;
      background-color: $c-font-main-light;
      margin-bottom: 5px;
    }
  }
  .bgc-blue {
    background-color: $c-tour-bg-blue;
  }
  .bgc-yellow {
    background-color: $c-tour-bg-yellow;
  }
  .fs-15 {
    font-size: 15px;
  }
  .ml-15px {
    margin-left: 15px;
  }
  .lh-2 {
    line-height: 2.1 !important;
    margin-bottom: 6px !important;
  }

  // 开放时间
  .color-yellow {
    * {
      color: $c-tour-font-yellow !important;
    }
  }

  .opening-hour {
    height: 422px;
    padding: 0 50px;
    vertical-align: top;

    img {
      margin-top: 20px;
      margin-left: 20px;
      height: 108px;
      vertical-align: top;
    }
    .minor-title {
      font-size: 47px;
      line-height: 50px;
    }
    .minor-content {
      font-size: 25px;
      line-height: 50px;
    }
    &:first-child {
      padding-right: 130px;
      background-image: url('../../../static/images/tour/bg-flower-b.png');
      background-repeat: no-repeat;
      background-size: auto 550px;
      background-position: -115px -45px;
    }
    &:last-child {
      padding-left: 130px;
      background-image: url('../../../static/images/tour/bg-flower-b.png');
      background-repeat: no-repeat;
      background-size: auto 550px;
      background-position: 115px -45px;
    }
  }
  .opening-hour-content {
    display: inline-block;
    padding: 126px 0 0 0;
  }
  .opening-hour-content-title {
    height: 50px;
    background: url('../../../static/images/public/left-big-active.png') 0
        center no-repeat,
      url('../../../static/images/public/right-big-active.png') 100% center
        no-repeat;
    background-size: auto 100%, auto 100%;
    margin-bottom: 37px;
    font-size: 47px;
  }

  // 购票指南
  .ticket-page {
    .tl-li {
      padding-bottom: 30px;
    }
    .minor-title {
      line-height: 55px;
    }
    .minor-content {
      line-height: 35px;
    }
  }
  .ticket-bg-flower {
    background-image: url('../../../static/images/tour/bg-flower-y.png');
    background-repeat: no-repeat;
    background-size: auto 620px;
    background-position: 455px 110px;
  }
  .ticket-left,
  .ticket-right {
    vertical-align: top;
  }
  .ticket-left {
    width: 65%;
    padding: 32px 40px 0 76px;
  }
  .tl-li {
    padding-bottom: 25px;
    .tl-number {
      width: 28px;
      height: 21px;
      left: -45px;
      top: 15px;
    }
  }

  .ticket-right {
    width: 35%;
    .tl-li {
      height: 150px;
      padding: 32px 0 0 66px;
      background-color: $c-tour-0;
      img {
        left: 20px;
        top: 44px;
      }
    }
  }

  // 交通信息
  .transportation {
    height: 600px;
    .point {
      display: inline-block;
      width: 8px;
      height: 8px;
      border: 1px solid $c-white;
      border-radius: 50%;
      top: 19px;
      left: -23px;
    }
    .minor-title {
      line-height: 45px;
    }
    .tl-number {
      width: 19px;
      height: 15px;
      top: 15px;
      left: -28px;
    }
    .transportation-li {
      padding: 0px 80px 35px 80px;
    }

    .minor-content {
      line-height: 25px;
    }
    .self-driving {
      .minor-content {
        line-height: 35px;
      }
      .point {
        top: 15px;
      }
    }
    .parking {
      .point {
        top: 9px;
      }
    }
    .transportation-tab-title {
      height: 26px;
      line-height: 26px;
      margin: 54px 0 30px 0;
    }
    .transportation-tab-option {
      font-size: 24px;
      color: $c-white;

      background-position: center;
      background-size: auto 0;
      background-repeat: no-repeat;
      background: url('../../../static/images/public/left-big.png') 22% center
          no-repeat,
        url('../../../static/images/public/right-big.png') 78% center no-repeat;
      background-size: auto 100%, auto 100%;

      &:hover {
        transition: all 0.35s;
        color: $c-tour-bg-yellow;
      }

      &.active {
        transition: all 0.35s;
        color: $c-tour-bg-yellow;
        background: url('../../../static/images/public/left-big-active.png') 22%
            center no-repeat,
          url('../../../static/images/public/right-big-active.png') 78% center
            no-repeat;
        background-size: auto 100%, auto 100%;
      }
    }
    .transportation-right {
      background-image: url('../../../static/images/tour/bg-flower-b.png');
      background-repeat: no-repeat;
      background-size: auto 580px;
      background-position: 435px 135px;
    }
  }

  // 游览须知
  .instructions {
    background-image: url('../../../static/images/tour/bg-flower-y.png');
    background-repeat: no-repeat;
    background-size: auto 600px;
    background-position: 700px -30px;
    padding: 12px 0 33px 0;
    .instructions-li {
      padding: 28px 405px 0 124px;
      li {
        line-height: 1.2;
        padding-left: 10px;
        border-left: 1px solid $c-white;
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .instructions-li-content {
        padding-bottom: 12px;
      }
      .instructions-icon {
        top: -8px;
        left: -90px;
        width: 60px;
        height: 60px;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url('../../../static/images/tour/no-smoking.png');
      }

      &:nth-child(2) {
        .instructions-icon {
          top: 2px;
          width: 66px;
          height: 66px;
          background-image: url('../../../static/images/tour/civilization.png');
        }
      }
      &:nth-child(3) {
        .instructions-icon {
          top: 8px;
          width: 54px;
          height: 54px;
          background-image: url('../../../static/images/tour/obey.png');
        }
      }
    }
    .obey {
      padding-top: 20px;
      li {
        padding-left: 0px;
        border-left: 0 none;
      }
    }
  }
}
</style>
